// Toggle interactivity - use jQuery SlideToggle if needed
(function($){
	$(".wp-block-theme-blocks-toggle .toggle-header").on( "click", function() {
		$(this).next().slideToggle("300", function() {
			$(this).parent().toggleClass("expanded");
		});
	});
	$(".wp-block-theme-blocks-expandable-summary").each(function() {
		// add prevew text element
		$('.toggle-body', this).prepend(addTextPreview($('.toggle-body .full-text', this), 19));

		// store the height of the preview text element in data attribute
		$('.toggle-body .preview-text', this).data('prevHeight', $('.toggle-body .preview-text', this).height());

		// hide the full text so only preview text is displayed
		$('.toggle-body .full-text', this).hide();

		// give the full text element the max-height of the preview text
		var prevHeight = $('.toggle-body .preview-text', this).data("prevHeight");
		$('.toggle-body .full-text', this).css('max-height', prevHeight);

	}).click(function() {
		$(this).toggleClass("expanded");
		
		if ($(this).hasClass('expanded')) {
			// hide preview text and gradually show full text 
			$('.toggle-body p.preview-text', this).hide();
			$('.toggle-body .full-text', this).show();
			$('.toggle-body .full-text', this).animate({'maxHeight': 500}, 400);
		}
		else {
			// gradually hide full text, then swap in the preview text
			var prevHeight = $('.toggle-body .preview-text', this).data("prevHeight");
			$('.toggle-body .full-text', this).animate({'maxHeight': prevHeight}, 400, function() {
				$('.wp-block-theme-blocks-expandable-summary .toggle-body .full-text').hide();
				$('.wp-block-theme-blocks-expandable-summary .toggle-body p.preview-text').show();			
			});	
		}
	});




	/**
	 * 
	 * takes one string and shortens it, appending ... at the end
	 * @param {html element} element 
	 * @param {int} maxWords 
	 * @returns new HTML element to append to document
	 */
	function addTextPreview(element, maxWords){
		let previewElement = '<p class="preview-text">'+$(element).text()+'</p>';

		// get words from element
		const words = $(element).text().split(/\s+/);

		// if element has more words than the maxWords trim the string
		if (words.length > maxWords ) {			
			// shorten the string and append "..."
			let shortString = words.slice(0,maxWords).join(" ") + "...";
			previewElement = '<p class="preview-text">'+shortString+'</p>';
		}
		// return new element
		return previewElement;
	}
	
})(jQuery);